export const EXPORT_FILENAME_PREFIX = 'organizations';

export const EXPORT_EXTENSION = 'csv';

export const EXPORT_STARTED_MESSAGE = 'backoffice.organizations.export_started';
